module.exports = __webpack_public_path__ + "img/scroll-bg-5.5831e61a.png";